import {
  LoggingPort,
  LogLevel,
  LogMessageParam,
  LogTransportPort,
} from '../../ports'

type LogLabelsParam = Record<string, string | number | boolean>

export class LoggingAdapter implements LoggingPort {
  constructor(private readonly logTransport: LogTransportPort) {}

  info(message: LogMessageParam | unknown, labels?: LogLabelsParam): void {
    this.callTransport('INFO', message, labels)
  }

  warn(message: LogMessageParam | unknown, labels?: LogLabelsParam): void {
    this.callTransport('WARN', message, labels)
  }

  error(error: LogMessageParam | unknown, labels?: LogLabelsParam): void {
    this.callTransport('ERROR', error, labels)
  }

  private callTransport(
    level: LogLevel,
    message: LogMessageParam | unknown,
    labels?: LogLabelsParam
  ): void {
    if (message instanceof Error || typeof message === 'string') {
      this.logTransport[level](message, labels)
      return
    }

    try {
      this.logTransport[level](JSON.stringify(message), labels)
    } catch (e) {
      console.error('Could not stringify message', e)
    }
  }
}
